import type { Collection } from "@/types";

export const collections: Collection[] = [
  {
    id: 1,
    title: ["BRASS", "COLLECTION"],
    category: "Brass",
    collectionNumber: "01",
    location: "Moradabad — India",
    description:
      "Our signature brass collection showcases handcrafted candle holders, trays, vases, sculptures, and decorative accents. Every piece is meticulously polished and finished by experienced artisans, blending traditional Indian craftsmanship with contemporary aesthetics for luxury interiors worldwide.",
    backgroundImage: "/hero/brassv2.webp",
    cardImage: "/hero/brassv2.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=brass",
    },
  },
  {
    id: 2,
    title: ["COPPER", "COLLECTION"],
    category: "Copper",
    collectionNumber: "02",
    location: "Moradabad — India",
    description:
      "Crafted from premium-grade copper, this collection features elegant serveware, drinkware, kitchen essentials, and decorative accessories. Combining timeless beauty with exceptional durability, each product reflects the heritage of skilled Indian metal artisans.",
    backgroundImage: "/hero/copper22.webp",
    cardImage: "/hero/copper22.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=copper",
    },
  },
  {
    id: 3,
    title: ["WOOD", "COLLECTION"],
    category: "Wood",
    collectionNumber: "03",
    location: "Moradabad — India",
    description:
      "Designed using sustainably sourced hardwoods, our wooden collection includes decorative accents, serving boards, storage pieces, and handcrafted furniture. Every creation celebrates natural textures while delivering outstanding quality and timeless appeal.",
    backgroundImage: "/hero/woodv2.webp",
    cardImage: "/hero/woodv2.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=wood",
    },
  },
  {
    id: 4,
    title: ["MARBLE", "COLLECTION"],
    category: "Marble",
    collectionNumber: "04",
    location: "Moradabad — India",
    description:
      "Our marble collection combines luxurious natural stone with refined craftsmanship to create sophisticated trays, coasters, tabletops, décor, and lifestyle accessories. Each piece is carefully shaped and polished to reveal the beauty of genuine marble.",
    backgroundImage: "/hero/marblev2.webp",
    cardImage: "/hero/marblev2.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=marble",
    },
  },
  {
    id: 5,
    title: ["ALUMINIUM", "COLLECTION"],
    category: "Aluminium",
    collectionNumber: "05",
    location: "Moradabad — India",
    description:
      "Lightweight, durable, and versatile, our aluminium collection features modern home décor, planters, bowls, trays, and functional accessories. Precision craftsmanship and contemporary finishes make every piece suitable for premium international markets.",
    backgroundImage: "/hero/aluminiumv2.webp",
    cardImage: "/hero/aluminiumv2.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=aluminium",
    },
  },
  {
    id: 6,
    title: ["HOME", "DECOR"],
    category: "Home Decor",
    collectionNumber: "06",
    location: "Moradabad — India",
    description:
      "Transform living spaces with our thoughtfully curated home décor collection featuring mirrors, sculptures, planters, wall art, decorative accessories, and tabletop accents. Every design is created to elevate interiors with elegance and lasting style.",
    backgroundImage: "/hero/home-decor.webp",
    cardImage: "/hero/home-decor.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=home-decor",
    },
  },
  {
    id: 7,
    title: ["FURNITURE", "COLLECTION"],
    category: "Furniture",
    collectionNumber: "07",
    location: "Moradabad — India",
    description:
      "Our handcrafted furniture collection features coffee tables, side tables, consoles, shelving units, seating, and accent furniture. Combining premium materials with exceptional craftsmanship, every piece is designed for comfort, functionality, and timeless sophistication.",
    backgroundImage: "/hero/furniturev2.webp",
    cardImage: "/hero/furniturev2.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=furniture",
    },
  },
  {
    id: 8,
    title: ["LIGHTING", "COLLECTION"],
    category: "Lighting",
    collectionNumber: "08",
    location: "Moradabad — India",
    description:
      "Illuminate interiors with handcrafted pendant lights, table lamps, floor lamps, chandeliers, lanterns, and wall fixtures. Our lighting collection combines artistic design with precision engineering to create warm, luxurious spaces across the globe.",
    backgroundImage: "/hero/lightingv2.webp",
    cardImage: "/hero/lightingv2.webp",
    button: {
      label: "Explore Collection",
      href: "/products?category=lighting",
    },
  },
];